export enum RegisterEvaluationChartFormField {
  CourseInfoId = 'courseInfoId',
  ChartRound = 'chartRound',
  ChartTypeNum = 'chartTypeNum',
}
